export default "__VITE_ASSET__D8Q7y5lH__"